import { memo, useMemo } from "react";
import { DragOverlay, useDndContext } from "@dnd-kit/core";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { BlockPreview } from "@circle-react-shared/BuilderUI/BlockList/BlockPreview";
import { droppableAcceptState } from "@circle-react-shared/BuilderUI/Helpers/droppableAcceptsDraggable";
import { useBuilderStore } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { ELEMENT_CATEGORIES } from "../ElementsList/useCategorizedElementsList";
import { isTemplateExport } from "../Helpers/typePredicates";

export const BlockCardDragOverlay = memo(() => {
  const { active: draggable, over: droppable } = useDndContext();
  const dragAndDropType = useBuilderStore(state => state.dragAndDropType);
  const draggingTemplate = useBuilderStore(state => state.draggingTemplate);

  const isElementType = useMemo(() => {
    if (!draggingTemplate || isTemplateExport(draggingTemplate)) return false;

    const categories = draggingTemplate.meta.category || [];

    return categories.some(
      category => category?.name && ELEMENT_CATEGORIES.includes(category.name),
    );
  }, [draggingTemplate]);

  const dropState = useMemo(() => {
    if (!draggable || !droppable) return null;
    return droppableAcceptState(droppable, draggable);
  }, [droppable, draggable]);

  if (dragAndDropType === "disabled" || !draggingTemplate) return null;

  return (
    <DragOverlay dropAnimation={null}>
      <div
        className={classNames("pointer-events-none", {
          "cursor-grabbing": dropState !== "reject",
          "cursor-no-drop": dropState === "reject",
        })}
      >
        <BlockPreview
          block={draggingTemplate}
          isOverlay
          isElementType={isElementType}
        />
      </div>
    </DragOverlay>
  );
});

BlockCardDragOverlay.displayName = "BlockCardDragOverlay";
